import { Input, Output, EventEmitter } from "@angular/core";
import { GridComponent } from "./grid.component";

export interface GridOptions {
    filtrable: boolean;
    sortable: boolean;
    editable: boolean;
    removable: boolean;
    headers: GridHeader[];
}

export interface GridHeader {
    displayName: string;
    propertyName: string;
    filter: string;
    isCheckbox: boolean;
    propertyType: string;
    isInitSort: boolean;
    isInitSortAsc: boolean;
    showTooltip: boolean;
    isVisible: boolean;
    dateFormat: string;
}

export interface GridRequest {
    filter: any;
    orderBy: string;
    isAscending: boolean;
    pageNumber: number;
    pageSize: number;
    withRestoring: boolean;
    isModal: boolean;
}

export interface GridResponse {
    elements: any[];
    count: number;
    pageNumber: number;
    restoredFilters: any[];
    orderBy: string;
    isAscending: boolean;
    columnsSettings: string;
}

export interface CustomButton {
    getButtonClass(row: any): {};
    hasIcon: boolean;
    displayName: string;
    getIconClass(row: any): {};
    actionName: string;
    isDisabled(row: any): boolean;
    isVisible(row: any): boolean;
    getTooltipText(row: any): string;
}

export interface CustomRow {
    getRowClasses(row: any): {};
}

export interface CustomButtonAction {
    actionName: string;
    selectedRow: any;
}

export class GridMainFilter {    
    internalName: string;    
    value: string;
}

export enum GroupFunction {
    sum,
    avg,
    min,
    max
}

export class GoupedColumn {
    name: string;
    func: GroupFunction;
}

export enum SelectionMode {
    none,
    single,
    multi
}

export class SortedColumn {
    columnName: string;
    isAscending: boolean;
}

export class GridSelection {
    @Input() selectionMode: SelectionMode = SelectionMode.none;
    @Output() onItemSelected = new EventEmitter<any>();

    public isOnDialog: boolean = false;

    protected _grid: GridComponent;

    public getSelectedItems(): any[]{
        return this._grid.getSelectedItems();
    }
}

export interface RowAppearance {
  rowCustomClass: string;
}